import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocale } from '@active/react-utils/i18n';
import pubSubInstance from '../../../../../../shared/utils/pubSub';
import { useCreateApplePayAccountMutation, useGetApplePaySessionMutation } from '../../../../../../store/services/common/payment/paymentApi';
import { useLogTrackMutation } from '../../../../../../store/services/common/logTrack/logTrackApi';
import { applePayment } from './applePayUtils';

export default function useApplePay({
  showDetailInfo = false, collectBillingInfo = false, yourPayment,
}) {
  const { i18n } = useLocale();
  const {
    widgetNameSpace, paymentCountryCode,
  } = useSelector(state => state.propsData);
  const {
    entities: {
      orderInfo,
      envParams: { enablePreviewMode } = {},
    },
  } = useSelector(state => state.mainStateData);
  const {
    entities: {
      paymentMethods: {
        applePayInfo,
      },
    },
  } = useSelector(state => state.paymentMethods);

  const [ getApplePaySession ] = useGetApplePaySessionMutation();
  const [ createApplePayAccount ] = useCreateApplePayAccountMutation();
  const [ logTrack ] = useLogTrackMutation();

  const handleSubmit = useCallback(() => {
    return new Promise((resolve) => {
      const initParams = {
        i18n,
        showDetailInfo,
        collectBillingInfo,
        getApplePaySession,
        createApplePayAccount,
        commitCallback: resolve,
        paymentCountryCode,
        applePayInfo,
        orderInfo,
        yourPayment,
        logTrack,
        enablePreviewMode,
      };
      applePayment.startApplePayProcess(initParams);
    });
  }, [ applePayInfo, orderInfo, paymentCountryCode, showDetailInfo, collectBillingInfo,
    i18n, getApplePaySession, createApplePayAccount, yourPayment, logTrack ]);

  useEffect(() => {
    pubSubInstance.subscribe(`${widgetNameSpace}-payment-item-submit`, handleSubmit);
    return () => {
      pubSubInstance.unsubscribe(`${widgetNameSpace}-payment-item-submit`, handleSubmit);
    };
  }, [ widgetNameSpace, handleSubmit ]);

  useEffect(() => {
    pubSubInstance.subscribe(`${widgetNameSpace}-preview-submit`, handleSubmit);
    return () => {
      pubSubInstance.unsubscribe(`${widgetNameSpace}-preview-submit`, handleSubmit);
    };
  }, [ widgetNameSpace, handleSubmit ]);
}
